import PropTypes from 'prop-types';
import { createContext, useEffect, useReducer } from 'react';
import { dispatch as storeDispatch } from 'store';

import accountReducer from 'store/accountReducer';
import { LOGIN, LOGOUT } from 'store/actions';
import { getAcmDashboardData } from 'store/slices/acmDashboard';

import Loader from 'ui-component/Loader';
import axios from 'utils/axios';

const initialState = {
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    accessToken: null
};

const setSession = (serviceToken) => {
    if (serviceToken) {
        localStorage.setItem('ab_id_token', serviceToken);
        axios.defaults.headers.common.Authorization = `Bearer ${serviceToken}`;
    } else {
        localStorage.removeItem('ab_id_token');
        delete axios.defaults.headers.common.Authorization;
    }
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //
export const CustomContext = createContext(null);

export const CustomCognitoProvider = ({ children }) => {
    const [state, dispatch] = useReducer(accountReducer, initialState);

    useEffect(() => {
        const init = () => {
            const token = window.localStorage.getItem('ab_id_token');
            if (token) {
                setSession(token);
                storeDispatch(getAcmDashboardData());
                dispatch({
                    type: LOGIN,
                    payload: {
                        isLoggedIn: true,
                        accessToken: token
                    }
                });
            } else {
                dispatch({
                    type: LOGOUT
                });
            }
        };

        init();
    }, []);

    const login = async (serviceToken) => {
        setSession(serviceToken);
        dispatch({
            type: LOGIN,
            payload: {
                isLoggedIn: true,
                accessToken: serviceToken
            }
        });
    };

    const logout = () => {
        setSession(null);
        dispatch({ type: LOGOUT });
    };

    if (state.isInitialized !== undefined && !state.isInitialized) {
        return <Loader />;
    }

    return <CustomContext.Provider value={{ ...state, login, logout }}>{children}</CustomContext.Provider>;
};

CustomCognitoProvider.propTypes = {
    children: PropTypes.node
};

export default CustomContext;
